import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import { FormikErrors } from "formik";
import { getErrorMessage } from "helpers/formik-helpers";
import { GeneralFeedData } from "./constants";

interface GeneralFeedTableProps {
  methodReserved: boolean;
  values: GeneralFeedData;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => Promise<void> | Promise<FormikErrors<GeneralFeedData>>;
  errors: FormikErrors<GeneralFeedData>;
  isEB_FEED: boolean;
}

export const GeneralFeedTable = ({
  values,
  setFieldValue,
  errors,
  methodReserved,
  isEB_FEED,
}: GeneralFeedTableProps) => {
  return (
    <TableContainer>
      <TableHead>
        <TableRow>
          <TableCell align="center">PlateBarcode</TableCell>
          <TableCell align="center">Aspirate Vol</TableCell>
          <TableCell align="center">Dispense Vol</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {values.plates.map((item, index) => (
          <TableRow>
            <TableCell>{item?.plateBarcode}</TableCell>
            <TableCell>
              <NumberField
                id="outlined-basic"
                label="Aspirate Vol"
                size="small"
                value={item.aspirateVol}
                onChange={(val) =>
                  setFieldValue(`plates[${index}].aspirateVol`, parseInt(val))
                }
                disabled={methodReserved || isEB_FEED}
                hasError={
                  !methodReserved &&
                  !!getErrorMessage(errors, `plates[${index}].aspirateVol`)
                }
                errorMessage={
                  !methodReserved &&
                  getErrorMessage(errors, `plates[${index}].aspirateVol`)
                }
              />
            </TableCell>
            <TableCell>
              <NumberField
                id="outlined-basic"
                label="Dispense Vol"
                size="small"
                value={item.dispenseVol}
                onChange={(val) =>
                  setFieldValue(`plates[${index}].dispenseVol`, parseInt(val))
                }
                disabled={methodReserved || isEB_FEED}
                hasError={
                  !methodReserved &&
                  !!getErrorMessage(errors, `plates[${index}].dispenseVol`)
                }
                errorMessage={
                  !methodReserved &&
                  getErrorMessage(errors, `plates[${index}].dispenseVol`)
                }
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
};
